import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import * as moment from "moment";
import {
  BootstrapTable, TableHeaderColumn
} from "react-bootstrap-table";
import { Button, Classes, Dialog } from "@blueprintjs/core";
import { observable } from "mobx";
import { Pager } from "../utils/Pager";
import { IconButton } from "@mui/material";


@observer
export class ReleasesPage extends React.Component<{}, {}> {
  obs = observable({
    open_visualiza_descricao: false,
    description: "" as string,
    version: "" as string,
    current_page: 1 as number,
    currentSteps: 1
  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    AppStore.setTitle("Histórico de Atualizações");
  }

  handlePageChange = async (page: number) => {

    await AppStore.handleIndexReleases(page);

    this.obs.current_page = page;

  };

  async handleCloseModalUpdates(version) {

    await AppStore.handleUpdatesModal(AppStore.obs1.usuario._id, version)

    if (AppStore.obs1.result_ok) {

      await AppStore.loadUsuario()

    }

  }

  render() {

    let rows = AppStore.obs1.releases?.map(emp => {
      return (
        {
          id: emp._id,
          title: emp.title,
          version: emp.version,
          description: emp.description,
          new: emp.new,
          inserted_at: `${moment(emp.inserted_at).add(3, "hours").format("DD/MM/YY")} às ${moment(emp.inserted_at).add(3, "hours").format("HH:mm")}`
        }
      )
    })

    const formatVisualizaDetalhes = (cell, row) => {
      return (
        <>
          <IconButton onClick={(e) => handleViewDetalhes(row)}>
            <img src="/images/view.png" width="18px" />
          </IconButton>
        </>
      )

    }

    const handleViewDetalhes = (row: any) => {
      this.obs.description = row.description
      this.obs.version = row.title

      this.obs.open_visualiza_descricao = true

      if(formatVersion(row.version) > formatVersion(AppStore.obs1.usuario.version_update)){

        this.handleCloseModalUpdates(row.version)

      }

    }

    const formatTitle = (cell, row) => {

      if (row.new) {
        return (<div>
          {row.title}
          &nbsp;
          <span className="new-tag-nav-new">NOVO</span>
        </div>)
      }

      return row.title

    }

    const formatVersion = (version) => {

      if (!version) return 0

      return parseInt(version.replace(/\./g, ""))

    }

    return (
      <>

        <div className="dashboard-page">
          <MDBRow>
            <MDBCol md="12">
              <p>
                Abaixo listamos as todas as nossas notas de alterações já realizadas.
              </p>

              <BootstrapTable className="TableDefault historicoReleases" data={rows}>
                <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%"> # </TableHeaderColumn>
                <TableHeaderColumn dataFormat={formatTitle} width="70%">Titulo</TableHeaderColumn>
                <TableHeaderColumn dataField="version" width="20%">Versão</TableHeaderColumn>
                <TableHeaderColumn dataField="inserted_at" width="20%">Data Alteração</TableHeaderColumn>
                <TableHeaderColumn dataFormat={formatVisualizaDetalhes} width="10%">Detalhes</TableHeaderColumn>
              </BootstrapTable>
            </MDBCol>
          </MDBRow>

          <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
            <Pager
              currentPage={this.obs.current_page}
              totalCount={AppStore.obs1.releases_length}
              pageSize={10}
              onPageChange={this.handlePageChange}
            />
          </div>

        </div>

        <Dialog isOpen={this.obs.open_visualiza_descricao} onClose={() => this.obs.open_visualiza_descricao = false} className="modal-releases">

          <div style={{ padding: "0px 0px 15px 0px" }}>

            <div dangerouslySetInnerHTML={{ __html: this.obs.description }} />

          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => this.obs.open_visualiza_descricao = false} />
          </div>

        </Dialog>

      </>
    );
  }
}

export default ReleasesPage;